import { Activity, Package, Users, CalendarRange, Gauge } from "lucide-react";
import { CAPS } from "../lib/csvAnalysis";
import { fmtNum, fmtCompact } from "../lib/format";
import { monthLabel } from "../lib/csvAnalysis";

export const KpiCards = ({ data }) => {
  const m = data.months;
  const cards = [
    { id: "kpi-total-visits", label: "Total visits", value: fmtNum(data.totalVisits), sub: `${fmtCompact(data.totalVisits / m.length)} / month avg`, icon: Activity, c: "text-ep-soft" },
    { id: "kpi-total-quantity", label: "Quantity picked", value: data.hasQty ? fmtNum(Math.round(data.totalQty)) : "—", sub: data.hasQty ? `${fmtNum(data.totalQty / Math.max(data.totalVisits, 1))} per visit` : "No qty column", icon: Package, c: "text-emerald-400" },
    { id: "kpi-unique-users", label: "Unique users", value: fmtNum(data.users.length), sub: `${fmtCompact(data.totalVisits / data.users.length)} visits / user`, icon: Users, c: "text-amber-400" },
    ...(data.hasHop ? [{ id: "kpi-picks-per-hour", label: "Picks / hour", value: fmtNum(data.totalPph), sub: `${(data.hopCoverage * 100).toFixed(1)}% of picks ≤ ${CAPS[data.capIdx] / 60} min hop`, icon: Gauge, c: "text-cyan-400" }] : []),
    { id: "kpi-total-months", label: "Months", value: m.length, sub: `${monthLabel(m[0])} → ${monthLabel(m[m.length - 1])}`, icon: CalendarRange, c: "text-violet-400" },
  ];
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-2 gap-4 ${data.hasHop ? "lg:grid-cols-5" : "lg:grid-cols-4"}`}>
      {cards.map((k, i) => (
        <div key={k.id} data-testid={k.id} className="panel p-5 hover-lift fade-up" style={{ animationDelay: `${i * 60}ms` }}>
          <div className="flex items-center justify-between">
            <p className="label-mono">{k.label}</p>
            <k.icon className={`h-4 w-4 ${k.c}`} />
          </div>
          <p className="mt-4 font-mono text-3xl text-slate-100 tracking-tight">{k.value}</p>
          <p className="mt-1 text-xs text-slate-500 font-mono">{k.sub}</p>
        </div>
      ))}
    </div>
  );
};
